<div class="d-flex flex-column align-items-center mt-5">
  <h3>Payment Info</h3>
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <h5 class="text-success">{{message}}</h5>
  </div>
</div>